import { render, staticRenderFns } from "./BaseSubmitButton.vue?vue&type=template&id=069944f2&scoped=true&lang=pug"
import script from "./BaseSubmitButton.vue?vue&type=script&lang=ts"
export * from "./BaseSubmitButton.vue?vue&type=script&lang=ts"
import style0 from "./BaseSubmitButton.vue?vue&type=style&index=0&id=069944f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069944f2",
  null
  
)

export default component.exports